export const Credit = "CREDIT";
export const Debit = "DEBIT";

const JournalType = { Credit, Debit };

export default JournalType;